import { api } from "@/api";
import type { Enums } from "@/enums";
import { isNotNil } from "es-toolkit";
import { defineStore } from "pinia";
import { ref } from "vue";

interface Profile {
    id: string;
    name: string;
    kind: Enums.UserTypeEnum.Values;
    email: string | undefined;
    avatar: string | undefined;
    username: string;
    privileges: Set<string>;
    employee?: {
        id: string;
        point: number | undefined;
    };
    notification: number;
}

export const useProfileStore = defineStore("profile", () => {
    const data = ref<Profile>();

    async function synchronize() {
        const profileResult = await api.user.profile().execute();
        if (profileResult === undefined) throw new Error("Failed to synchronize profile data");

        data.value = {
            id: profileResult.id,
            name: profileResult.name,
            kind: profileResult.kind,
            email: profileResult.email,
            avatar: profileResult.avatar,
            username: profileResult.username,
            privileges: new Set(["*", ...profileResult.privileges]),
            employee: undefined,
            notification: 0,
        };

        if (profileResult.kind === "associate" && isNotNil(profileResult.employee)) {
            data.value.employee = {
                id: profileResult.employee.id,
                point: profileResult.employee.point,
            };
        }

        if (isNotNil(profileResult.employee)) {
            const unread = await api.notification.unread().execute();
            if (unread !== undefined) data.value.notification = unread;
        }
    }

    return { data, synchronize };
});
